import React from 'react';

import { useMutation } from '@tanstack/react-query';

import FormContainer from '../../../FormContainer';

import useLenderHistoryForm from '../../../../../forms/loan/lenderHistory';
import LoanService from '../../../../../services/LoanService';
import { useUiContext } from '../../../../../context/UiContext';

/* const isEqual = (a, b) => {
  return (
    a?.lender_id === b?.lender_id &&
    moment(a?.effective_date).isSame(b?.effective_date) &&
    moment(a?.interest_effective_date).isSame(b?.interest_effective_date)
  );
};

const xor = (a, b) => {
  return !!(a !== b);
}; */

export default function LenderHistory({ loan, loanId, refetch }) {
  // const prevUpdateData = useRef({});

  const { showToast } = useUiContext();

  const { mutate: updateLoanWithLenderHistory, isPending } = useMutation({
    mutationFn: (formValues) => {
      return LoanService.updateLoan({
        loanId,
        formValues: { ...loan, ...formValues },
      });
    },
    onSuccess: () => {
      showToast({
        text: 'Lender history updated',
        type: 'success',
      });
      refetch();
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const form = useLenderHistoryForm(
    updateLoanWithLenderHistory,
    loan?.lender_history && loan?.lender_history.length ? loan : null
  );

  return (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6 flex justify-between w-full">
        Lender History
      </h2>
      <FormContainer
        form={form}
        submitButtonLabel="Save"
        isSubmitting={isPending}
        noBillComId
      />
    </div>
  );
}
